<template>
  <div
    class="ui-form-notice"
    :class="[`ui-form-notice--${tone}`]"
    :role="tone === 'danger' ? 'alert' : 'note'"
  >
    <span class="ui-form-notice__bar" aria-hidden="true"></span>
    <div class="ui-form-notice__body">
      <strong v-if="title" class="ui-form-notice__title">{{ $t(title) }}</strong>
      <div class="ui-form-notice__content"><slot /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiFormNotice',
  props: {
    title: { type: String, default: '' },
    tone: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'warning', 'danger', 'accent', 'neutral'].includes(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-form-notice {
  --ui-form-notice-color: var(--ui-color-primary);
  --ui-form-notice-color-rgb: var(--ui-color-primary-rgb);
  position: relative;
  min-width: 0;
  display: flex;
  align-items: stretch;
  color: var(--ui-text-secondary);
  border-top: 1px solid rgba(var(--ui-form-notice-color-rgb), .08);
  border-bottom: 1px solid rgba(var(--ui-form-notice-color-rgb), .08);
  background: linear-gradient(90deg, rgba(var(--ui-form-notice-color-rgb), .075), rgba(var(--ui-form-notice-color-rgb), .018));
  font-size: var(--ui-font-size-caption);
  line-height: 1.65;
}

.ui-form-notice__bar {
  width: 2px;
  flex: none;
  background: var(--ui-form-notice-color);
  box-shadow: 0 0 8px rgba(var(--ui-form-notice-color-rgb), .2);
}

.ui-form-notice__body {
  min-width: 0;
  padding: var(--ui-space-sm) var(--ui-space-md);
}

.ui-form-notice__title {
  display: block;
  margin-bottom: 2px;
  color: var(--ui-text-primary);
  font-size: var(--ui-font-size-caption);
  font-weight: var(--ui-font-weight-bold);
}

.ui-form-notice__content {
  overflow-wrap: anywhere;
}

.ui-form-notice--warning {
  --ui-form-notice-color: var(--ui-color-warning);
  --ui-form-notice-color-rgb: var(--ui-color-warning-rgb);
}

.ui-form-notice--danger {
  --ui-form-notice-color: var(--ui-color-danger);
  --ui-form-notice-color-rgb: var(--ui-color-danger-rgb);
}

.ui-form-notice--accent {
  --ui-form-notice-color: var(--ui-color-accent);
  --ui-form-notice-color-rgb: var(--ui-color-accent-rgb);
}

.ui-form-notice--neutral {
  --ui-form-notice-color: var(--ui-color-info);
  --ui-form-notice-color-rgb: var(--ui-color-info-rgb);
}
</style>

<style lang="scss">
.ui-form-notice {
  margin: 0 0 var(--ui-space-lg);
}

.form-card-stack > .ui-form-notice {
  margin-bottom: 0;
}
</style>
